import { useEffect, useState } from 'react';

export default function Preloader({ onDone }) {
  const [phase, setPhase] = useState('enter'); // enter → hold → exit

  useEffect(() => {
    const hold = setTimeout(() => setPhase('exit'), 1800);
    return () => clearTimeout(hold);
  }, []);

  useEffect(() => {
    if (phase !== 'exit') return;
    const done = setTimeout(onDone, 700);
    return () => clearTimeout(done);
  }, [phase, onDone]);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: '#07070a',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      opacity: phase === 'exit' ? 0 : 1,
      transition: 'opacity 0.7s cubic-bezier(0.4,0,0.2,1)',
      pointerEvents: phase === 'exit' ? 'none' : 'all',
    }}>

      {/* Ambient glow */}
      <div style={{
        position: 'absolute', top: '50%', left: '50%',
        transform: 'translate(-50%, -60%)',
        width: 420, height: 420,
        background: 'radial-gradient(ellipse, rgba(212,176,106,0.08) 0%, transparent 68%)',
        filter: 'blur(40px)',
        pointerEvents: 'none',
      }} />

      {/* Logo */}
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
        animation: 'plFadeUp 0.8s cubic-bezier(0.16,1,0.3,1) both',
      }}>
        {/* Gem facet icon */}
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" style={{ marginBottom: 10, animation: 'plSpin 6s linear infinite' }}>
          <polygon points="18,2 34,12 34,24 18,34 2,24 2,12" fill="none" stroke="rgba(212,176,106,0.5)" strokeWidth="0.8"/>
          <polygon points="18,2 34,12 18,18" fill="rgba(212,176,106,0.12)"/>
          <polygon points="34,12 34,24 18,18" fill="rgba(212,176,106,0.07)"/>
          <polygon points="34,24 18,34 18,18" fill="rgba(212,176,106,0.14)"/>
          <polygon points="18,34 2,24 18,18" fill="rgba(212,176,106,0.09)"/>
          <polygon points="2,24 2,12 18,18" fill="rgba(212,176,106,0.11)"/>
          <polygon points="2,12 18,2 18,18" fill="rgba(212,176,106,0.06)"/>
          <circle cx="18" cy="18" r="2.5" fill="rgba(212,176,106,0.7)"/>
        </svg>

        <div style={{ fontFamily: '"Cormorant Garamond", Georgia, serif', fontSize: 52, fontWeight: 300, fontStyle: 'italic', letterSpacing: '-0.02em', color: '#f6f1e7', lineHeight: 1 }}>
          Sudath
        </div>
        <div style={{ fontFamily: '"Montserrat", sans-serif', fontSize: 12, letterSpacing: '0.5em', color: '#d4b06a', textTransform: 'uppercase', fontWeight: 500 }}>
          Gems
        </div>

        {/* Gold divider line */}
        <div style={{ marginTop: 28, width: 120, height: 1, background: 'rgba(212,176,106,0.2)', position: 'relative', overflow: 'hidden', borderRadius: 1 }}>
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(90deg, transparent, #d4b06a, transparent)',
            animation: 'plSweep 1.4s cubic-bezier(0.4,0,0.2,1) 0.3s both',
          }} />
        </div>

        <p style={{
          marginTop: 18, fontFamily: '"Montserrat", sans-serif',
          fontSize: 9.5, letterSpacing: '3px', textTransform: 'uppercase',
          color: 'rgba(212,176,106,0.45)', fontWeight: 400,
          animation: 'plFadeUp 0.8s cubic-bezier(0.16,1,0.3,1) 0.5s both',
        }}>
          Ceylon · Est. 1989
        </p>
      </div>

      <style>{`
        @keyframes plFadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes plSpin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes plSweep {
          from { transform: translateX(-100%); }
          to   { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
